import { api } from '@/api';
import type {
  CompanyQueryParams,
  CompanyResponse,
  CompanyLevelsResponse,
} from '../types';
import type { Level } from '@/features/company-admin/models';

export async function fetchCompanies(
  params: CompanyQueryParams
): Promise<CompanyResponse> {
  const queryParams: Record<string, string | number | boolean | undefined> = {
    page: params.page,
    pageSize: params.pageSize,
    search: params.search || undefined,
    sortBy: params.sortBy || undefined,
    sortOrder: params.sortOrder || undefined,
    stopAtCompany: params.stopAtCompany || undefined,
  };

  if (params.categories && params.categories.length > 0) {
    queryParams.categories = params.categories.join(',');
  }

  return api.get<CompanyResponse>('/v1/companies', { params: queryParams });
}

/**
 * Fetch company levels for a specific company
 * @param companyId - The UUID of the company
 * @param locale - The language used for localized level names
 * @returns Promise with category response
 */
export async function fetchCompanyLevels(
  companyId: string,
  locale: string
): Promise<Level[]> {
  return api
    .get<CompanyLevelsResponse>(`/v1/companies/${companyId}/levels`, {
      params: { locale },
    })
    .then((response) => {
      return response.levels ?? []
    })
}

export async function deleteCompanies(companyIds: string[]): Promise<void> {
  await api.delete('/v1/companies', { companyIds });
}
